import {useQuery} from "@tanstack/react-query";
import {readProjectDetailApi} from "../../../../api/correspondent/projectApi";

type Props = {
    id: number;
};

export const useReadProjectDetail = ({id}: Props) => {
    const {data} = useQuery({
        queryKey: ["readProjectDetail", id],
        queryFn: async () => await readProjectDetailApi(id),
        select: (res) => res?.data.result ?? null,
        enabled: id !== 0
    });
    return {data};
};
